import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';
import { useEffect, useState } from 'react';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;

export default function HesapFooter() {
  const [footerText, setFooterText] = useState('');

  useEffect(() => {
    fetch(`${API}/site-settings`).then(r => r.json())
      .then(d => setFooterText(d.footer_text || ''))
      .catch(() => {});
  }, []);

  if (!footerText) return null;

  return (
    <footer className="bg-slate-900 text-slate-400 text-xs text-center py-2 px-4 border-t border-slate-800"
      data-testid="hesap-footer">
      {footerText}
    </footer>
  );
}
